import { render, staticRenderFns } from "./AppHelp.vue?vue&type=template&id=15d413a3&"
import script from "./AppHelp.vue?vue&type=script&lang=ts&"
export * from "./AppHelp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.14_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports